import React from 'react'
import { convertToSafariCompatibleDate } from 'AccountsUtils'
import { getCookie } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'
import classes from './CalendarIcon.module.css'

const calendarIcon = ({ travelDate, isPast }) => {
  const isRTL = getCookie('selectedLanguage') === 'ar'
  const dateObj = (dateStr => {
    let dateString = new Date(convertToSafariCompatibleDate(dateStr))
    dateString = dateString.toDateString()
    return dateString
  })(travelDate)
  const displayMonth = dateStr => {
    let month = ''
    if (dateStr) {
      month = dateObj.substr(4, 3)
    }
    return month
  }
  const displayDay = dateStr => {
    let day = ''
    if (dateStr) {
      day = dateObj.substr(0, 3)
    }
    return day
  }
  const { day, date, month, past } = classes
  const pastClass = isPast ? past : null
  return (
    <time className={pastClass}>
      <span
        className={month}
        style={{
          backgroundColor: isInFlyinDomain() ? '#194e91' : ''
        }}
      >
        {displayMonth(travelDate)}
      </span>
      <span className={date}>{dateObj.substr(8, 2)}</span>
      <span className={day}>{displayDay(travelDate)}</span>
    </time>
  )
}

export default calendarIcon
